import { ColorEnum } from '@/constants/color'
import CancelButton from '@/features/common/buttons/CancelButton'
import ConfirmButton from '@/features/common/buttons/ConfirmButton'
import ProductName from '@/features/pos/components/ProductConfigurationModal/parts/ProductName'
import QuantitySelector, {
    QuantitySelectorProps,
} from '@/features/pos/components/ProductConfigurationModal/parts/QuantitySelector'
import Modal from '@/features/ui/components/Modal'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface ContainerModalProps {
    name: string
    disabled: boolean
    loading: boolean
    quantity: QuantitySelectorProps
    onCancel: () => void
    onConfirm: () => void
}

const ContainerModal: FC<ContainerModalProps> = ({
    name,
    disabled,
    loading,
    quantity,
    onCancel,
    onConfirm,
}) => (
    <Modal contentVariant="wide">
        <View style={styles.content}>
            <ProductName>{name}</ProductName>
            <View style={styles.footer}>
                <QuantitySelector {...quantity} />
                <View style={styles.actions}>
                    <View style={styles.column}>
                        <CancelButton disabled={loading} onPress={onCancel} />
                    </View>
                    <View style={styles.column}>
                        <ConfirmButton
                            disabled={disabled}
                            loading={loading}
                            onConfirm={onConfirm}
                        />
                    </View>
                </View>
            </View>
        </View>
    </Modal>
)

const styles = StyleSheet.create({
    content: {
        overflow: 'hidden',
        borderRadius: 16,
        backgroundColor: ColorEnum.GRAY_100,
    },
    footer: {
        backgroundColor: ColorEnum.VIOLET_100,
        borderRadius: 16,
        padding: 16,
        gap: 16,
    },
    actions: {
        flexDirection: 'row',
        gap: 16,
    },
    column: {
        flex: 1,
        minWidth: 0,
    },
})

export default ContainerModal
